<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: 'FinanceShareholderReport'
}
</script>

<style lang="css" scoped>

</style>